export default "__VITE_ASSET__CbV4IDWi__"